import { CardContent } from "types/CardContent";

const aboutCards: CardContent[] = [
	{title: 'Software Engineer', image: 'images/about/word_cloud_frontend.jpeg',
	description: "My career and biggest passion is software. I love problemsolving and create exciting products."},
	// {title: 'Coding 2', image: 'images/about/coding_2.jpeg'},
	{title: 'UI Design', image: 'images/about/design.png',
	description: "I also like to design stuff, mostly web UI, but 3D design also comes to mind."},
	{title: 'Powerlifting', image: 'images/about/deadlift_3d_img.png',
	description: "In my freetime I like to exercise and one of my favorite sport is powerlifting."},

];

export default aboutCards;